var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdEx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13zM9.509 12.04c-.293.425-.439 1.07-.439 1.935v.4c.007.818.154 1.439.444 1.861.292.423.714.634 1.267.634.445 0 .809-.211 1.092-.634l.063.536h1.253V9.286h-1.39v2.642c-.27-.352-.607-.527-1.013-.527-.56 0-.985.213-1.277.639zm1.111 3.372c-.11-.208-.166-.571-.166-1.091v-.366c0-.523.059-.887.176-1.092.117-.204.302-.307.555-.307.273 0 .478.13.614.39v2.408a.673.673 0 01-.618.366c-.264 0-.45-.103-.561-.308zm-5.83-.092h1.955l.38 1.452h1.53L6.424 9.676h-1.31l-2.218 7.096H4.41l.38-1.452zm1.638-1.194H5.103l.662-2.53.663 2.53zm11.513-.424h-2.232v1.881h2.641v1.19h-4.075V9.675h4.065v1.194H15.71v1.677h2.232v1.155zm3.548-2.203l-.614 1.564-.59-1.564h-1.467l1.194 2.578-1.247 2.695h1.472l.643-1.652.648 1.652h1.467l-1.248-2.695 1.204-2.578H21.49z"
  })));
}

export default __webpack_public_path__ + "6ebc31b7f51198fe812e9aa119d4ca7d.svg";
export { SvgAdEx as ReactComponent };